// frontend/src/configs/firebaseStorage.js
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDeUF5vYrYYkxCn1U0ezqgCAsSm3Pu6kX4",
  authDomain: "myportfolio-fecaa.firebaseapp.com",
  projectId: "myportfolio-fecaa",
  storageBucket: "myportfolio-fecaa.appspot.com",
  messagingSenderId: "396849228661",
  appId: "1:396849228661:web:e7a76971a39f555214c13c",
  measurementId: "G-2HHKYWEZ7P"
};

const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
const auth = getAuth(app);

export { auth, storage };
